import React from 'react';
import PropTypes from 'prop-types';
import { Table, TBody, TR, TD, Img } from 'oy-vey';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';
import { PRIMARY_COLOR } from '../../../constants';
import { textStyle } from '../../../helpers/getEmailStyles';

class BookingDeclinedQRPaymentGuest extends React.Component {

	static propTypes = {
		content: PropTypes.shape({
			hostName: PropTypes.string.isRequired,
			guestName: PropTypes.string.isRequired,
			listTitle: PropTypes.string.isRequired,
		}).isRequired

	};

	render() {
		const btnCenter = {
			textAlign: 'center'
		}
		const { content: { guestName, hostName, logo, siteName } } = this.props;

		return (
			<Layout>
				<Header color={PRIMARY_COLOR} backgroundColor="#F7F7F7" logo={logo} siteName={siteName} />
				<div>
					<Table width="100%" >
						<TBody>
							<TR>
								<TD style={textStyle}>
									<EmptySpace height={20} />
									<div>
										Hola {guestName},
									</div>
									<EmptySpace height={20} />
									<div>
										Lamentamos informarle que su anfitrión {hostName} rechazó su solicitud
										{' '}, Le recomendamos probar con otra propiedad.
									</div>
									<EmptySpace height={40} />
									<EmailSignature siteName={siteName} />
								</TD>
							</TR>
						</TBody>
					</Table>
					<EmptySpace height={40} />
				</div>
				<Footer siteName={siteName} />
				<EmptySpace height={20} />
			</Layout>
		);
	}

}

export default BookingDeclinedQRPaymentGuest;